export default __webpack_public_path__ + "static/media/chat_4.dbd5fc12.jpg";